//Principais
import { Component, inject, Inject, LOCALE_ID, OnInit } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { Router, RouterLink } from '@angular/router';
import { NgSelectConfig } from "@ng-select/ng-select";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";

//Models
import { ChamadoDeletar } from "src/app/shared/models/chamados/chamadoDeletar";
import { HistoricoChamado } from "src/app/shared/models/chamados/historico";
import { ListarChamados } from "src/app/shared/models/chamados/listar-chamados";
import { Diretoria } from "src/app/shared/models/diretoria/Diretoria";
import { Escola } from "src/app/shared/models/escola/Escola";
import { Turno } from "src/app/shared/models/escola/Turno";
//Services
import { formatDate } from "@angular/common";
import { NgbPagination } from "@ng-bootstrap/ng-bootstrap";
import { TresPontosComponent } from "components/tres-pontos/tres-pontos.component";
import { lastValueFrom } from "rxjs";
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { Perfil } from "src/app/shared/enums/Perfis/Perfis";
import { AlunosRecorrentes } from "src/app/shared/models/aluno/AlunosRecorrentes";
import { Categoria } from "src/app/shared/models/categoria/Categoria";
import { detalhesChamado } from "src/app/shared/models/chamados/detalhesChamado";
import { Envolvido } from "src/app/shared/models/chamados/envolvido";
import { ListarNaoOcorrencias } from "src/app/shared/models/nao-ocorrencia/ListarNaoOcorrencia";
import { AtribuicaoLoginSed, UserLoginSed } from "src/app/shared/models/sed/UserLogin";
import { CategoriaService } from "src/app/shared/services/categoria.service";
import { ChamadoService } from "src/app/shared/services/chamado.service";
import { ConcluirService } from "src/app/shared/services/concluir.service";
import { ConvivaErrorHandlingService } from "src/app/shared/services/convivaErrorHandlingService";
import { EnvolvidoService } from "src/app/shared/services/envolvido.service";
import { EscolaService } from "src/app/shared/services/escola.service";
import { NaoOcorrenciaService } from "src/app/shared/services/nao-ocorrencia.service";
import { PsicologoService } from "src/app/shared/services/psicologo.service";
import { angularCommonImports } from "src/app/shared/ui/angular-common";
import { convivaCommonImports } from "src/app/shared/ui/conviva-common";
import { libsCommonImports } from "src/app/shared/ui/libs-common";

@Component({
  selector: 'app-chamados-list',
  templateUrl: './chamados-list.component.html',
  styleUrls: ['./chamados-list.component.scss'],
  standalone: true,
  imports: [angularCommonImports, convivaCommonImports, libsCommonImports, NgbPagination, TresPontosComponent, RouterLink]
})
export class ChamadosListComponent implements OnInit {

  private escolaService = inject(EscolaService);
  private config = inject(NgSelectConfig);
  private chamadoService = inject(ChamadoService);
  private envolvidoService = inject(EnvolvidoService);
  private ConvivaErrors = inject(ConvivaErrorHandlingService);
  private authService = inject(AuthService);
  private spinnerService = inject(NgxSpinnerService);
  private toastr = inject(ToastrService);
  private psicologoService = inject(PsicologoService);
  private router = inject(Router);
  private categoriaService = inject(CategoriaService);
  private naoOcorrenciasService = inject(NaoOcorrenciaService);
  private concluirService = inject(ConcluirService)


  public page = 4;

  public userLogado: UserLoginSed | null;
  public atribuicoesLogin: AtribuicaoLoginSed;

  constructor(

    @Inject(LOCALE_ID) private locale: string
  ) {
    this.config.notFoundText = 'Não encontrado';
    this.userLogado = this.authService.getUser();

    if (this.userLogado != null && !this.userLogado.flPsicologo) {
      this.atribuicoesLogin = this.userLogado?.DadosUsuario[0];
    }
  }

  public gravidades = [{ id: 1, name: 'Amarelo' }, { id: 2, name: 'Vermelho' }];
  public anos: number[] = [];
  public diretorias: Diretoria[] = [];
  public escolas: Escola[] = [];
  public turnos: Turno[] = [];
  public lstChamados: ListarChamados[] = [];
  public detalheChamado: detalhesChamado;
  public lstNaoOcorrencias: ListarNaoOcorrencias[] = [];
  public lstAllChamados: ListarChamados[] = [];
  public alunosRecorrentes: AlunosRecorrentes[] = [];
  public formListarChamado!: FormGroup;
  public formModalEncaminhamento!: FormGroup;
  public formCadastrarHistorico!: FormGroup;
  public submitted = false;
  public showPesquisa = false;
  public showMenu = true;
  public showHistorico = false;
  public showStatus = false;
  public showConteudoChamado = false;
  public showModalExcluirChamado = false;
  public parametroIdChamado: any;
  public parametroIdEnvolvido: any;
  public statusCriada: any;
  public statusFechada: any;
  public itemEnvolvido: Envolvido;
  public lstEnvolvidos: Envolvido[] = [];
  public chamadoHistorico: ListarChamados;
  public chamadoSeleccionado: ListarChamados;
  public naoOcorrenciaSelecionada: ListarNaoOcorrencias | undefined;
  public descricaoExclusao = '';
  public dsHistoricoChamado: string;
  public chamadoARemover = 0;
  public submittedModal = false;
  public showDetalhesNaoOcorrencia = false;
  public tituloModalEncaminhamento: string;
  public categorias: Categoria[] = [];
  public get CoordenadorPsicologo() {
    return this.userLogado?.codigoPerfil === Perfil.CoordenadorPsicologo
      || (this.userLogado?.DadosUsuario?.some(s => s.CodigoPerfil === Perfil.CoordenadorPsicologo) ?? false);
  }
  public get form() { return this.formListarChamado.controls; }
  //Modal concluir
  public showModalConcluirChamado: boolean;
  public descricaoConcluir: string;
  public chamadoAConcluir: number;
  public chamadoSelecionado: number;
  public minDate: string = '2021-01-01';
  public maxDate: string = `${new Date().getFullYear()}-12-30`;

  public ngOnInit(): void {
    this.formListarChamado = new FormGroup({
      codigoDiretoria: new FormControl(null),
      codigoEscola: new FormControl(null),
      codigoTurno: new FormControl(null),
      codigoGravidade: new FormControl(null),
      codigoSubCategoria: new FormControl(null),
      codigoChamado: new FormControl(null),
      anoAtual: new FormControl(new Date().getFullYear(), [Validators.required]),
      dataInicio: new FormControl(null),
      dataFim: new FormControl(null)
    });

    this.formCadastrarHistorico = new FormGroup({
      dsHistoricoChamado: new FormControl(null),
    });

    this.getCategorias();
    this.getYears();

    if (this.CoordenadorPsicologo) {
      this.getDiretoriasPerfilDiretoria();
    } else if (this.userLogado?.flPsicologo) {
      this.getDiretoriasPerfilPsicologo();
    } else {
      if (this.atribuicoesLogin.NumeroComportamento == 1) {
        this.getDiretorias();
      }
      if (this.atribuicoesLogin.NumeroComportamento == 2) {
        this.getDiretoriasPerfilDiretoria();
      }
      if (this.atribuicoesLogin.NumeroComportamento == 3 || this.atribuicoesLogin.NumeroComportamento == 4) {
        this.getDiretoriasPerfilEscola();
      }
    }
  }

  public getYears() {
    const anoAtual = new Date().getFullYear();
    for (let ano = 2024; ano <= anoAtual; ano++) {
      this.anos.push(ano);
    }

  }

  public getDiretoriasPerfilDiretoria() {
    this.diretorias = [];
    this.escolas = [];

    this.diretorias = this.mapDiretoriasPermitidas(this.userLogado?.DadosUsuario);

    if (this.diretorias.length == 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();
    } else {
      this.form.codigoDiretoria.enable();
      this.ativaDiretoria();
    }

    this.getEscolas();
  }

  public getDiretoriasPerfilEscola() {

    this.diretorias = [];
    this.escolas = [];
    this.diretorias = this.mapDiretoriasPermitidas(this.userLogado?.DadosUsuario);

    if (this.diretorias.length == 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();
    } else {
      this.form.codigoDiretoria.enable();
      this.ativaDiretoria();
    }

    this.getEscolasPerfilEscola();
  }
  public getEscolasPerfilEscola() {

    const codigoDiretoriaSelecionada = this.form.codigoDiretoria.value;
    const atribuicoes = this.userLogado?.DadosUsuario ?? [];
    const atribuicoesFiltradas = codigoDiretoriaSelecionada
      ? atribuicoes.filter(x => x.CodigoDiretoria == codigoDiretoriaSelecionada)
      : atribuicoes;

    this.formListarChamado.get('codigoEscola')?.patchValue(null);
    this.zerarTurnos();

    this.escolas = [];
    atribuicoesFiltradas.forEach((item: AtribuicaoLoginSed) => {
      if (this.escolas.some(x => x.codigoEscola === item.CodigoEscola)) {
        return;
      }
      const escola = new Escola();
      escola.codigoEscola = item.CodigoEscola;
      escola.nomeEscola = item.NomeEscola;
      escola.codigoDiretoria = item.CodigoDiretoria;
      this.escolas.push(escola);
    });

    if (this.escolas.length == 1) {
      this.form.codigoEscola.setValue(this.escolas[0].codigoEscola);
      this.form.codigoEscola.disable();
    } else {
      this.form.codigoEscola.enable();
      this.ativaEscola();
    }
  }
  public ativaDiretoria() {
    if (!this.form.codigoDiretoria.value && this.userLogado?.codigoDiretoria && this.diretorias.some(x => x.codigoDiretoria == this.userLogado?.codigoDiretoria)) {
      this.formListarChamado.get('codigoDiretoria')?.setValue(this.userLogado?.codigoDiretoria);
    }
    if (this.userLogado !== null)
      this.authService.setUser(this.userLogado);
  }

  public ativaEscola() {
    if (this.userLogado?.codigoEscola && this.escolas.some(x => x.codigoEscola == this.userLogado?.codigoEscola))
      this.form.codigoEscola.setValue(this.userLogado?.codigoEscola);

    const codigoDiretoriaSelecionada = this.form.codigoDiretoria.value;
    const codigoEscolaSelecionada = this.form.codigoEscola.value;

    if (codigoDiretoriaSelecionada && codigoEscolaSelecionada) {
      this.getTurnos();
      this.OnPesquisar();
    }
    if (this.userLogado !== null)
      this.authService.setUser(this.userLogado);
  }

  public async getDiretorias() {
    this.spinnerService.show();
    const result = await lastValueFrom(await this.escolaService.getDiretoriaPorTipoDiretoria())
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    this.diretorias = result?.data;
    if (this.userLogado?.codigoDiretoria != undefined) {
      this.ativaDiretoria();
      this.getEscolas(true);
    }
    this.spinnerService.hide();
  }

  public async getEscolas(diretoriaLogada: boolean = false) {
    const codigoDE = this.userLogado?.codigoDiretoria != undefined && diretoriaLogada ? this.userLogado?.codigoDiretoria : this.formListarChamado.get('codigoDiretoria')?.value;
    if (this.userLogado?.flPsicologo) {
      this.zerarEscola();
      this.spinnerService.show();
      const result = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(this.form.codigoDiretoria.value ?? this.userLogado!.codigoDiretoria))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });
      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }
      this.escolas = result.data;
      this.spinnerService.hide();
      this.ativaEscola();
    } else
      if (this.atribuicoesLogin.NumeroComportamento == 1 || this.atribuicoesLogin.NumeroComportamento == 2) {
        this.zerarEscola();
        if (codigoDE != null) {
          this.spinnerService.show();
          const result = await lastValueFrom(await this.escolaService.getEscolasPorCodigoDiretoria(codigoDE))
            .catch((err) => {
              return this.ConvivaErrors.handleResultError(err);
            });
          if (!result.isSucess) {
            this.toastr.error(result.message, result.title);
            this.spinnerService.hide();
            return;
          }
          this.escolas = result.data;
          this.spinnerService.hide();
          this.ativaEscola();
        }
      } else if (this.atribuicoesLogin.NumeroComportamento == 3 || this.atribuicoesLogin.NumeroComportamento == 4) {
        this.getEscolasPerfilEscola();
      }
    if (this.userLogado !== null) {
      this.userLogado.codigoDiretoria = codigoDE == null ? 0 : codigoDE;
      this.authService.setUser(this.userLogado);
    }
  }

  public zerarEscola() {
    this.escolas = [];
    this.formListarChamado.get('codigoEscola')?.patchValue(null);
    this.zerarTurnos();
  }

  public async getTurnos() {
    const codigoEE = this.formListarChamado.get('codigoEscola');
    this.zerarTurnos();
    if (codigoEE?.value != null) {
      this.spinnerService.show();
      const result = await lastValueFrom(await this.escolaService.getTurnosPorCodigoCie(codigoEE?.value))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });
      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }
      this.turnos = result.data;
      if (this.turnos == null)
        this.toastr.warning('Não foi encontrados turnos para essa escola !');
      this.spinnerService.hide();
    }
    if (this.userLogado !== null) {
      this.userLogado.codigoEscola = codigoEE?.value == null ? 0 : codigoEE?.value;
      this.authService.setUser(this.userLogado);
    }
  }

  public zerarTurnos() {
    this.turnos = [];
    this.formListarChamado.get('codigoTurno')?.patchValue(null);
  }

  public async getCategorias() {
    this.spinnerService.show();
    const result = await lastValueFrom(await this.categoriaService.getCategoriasWithSub(0))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    this.categorias = result.data;
    this.spinnerService.hide();
  }

  public async OnPesquisar() {
    this.Voltar();
    this.submitted = true;
    this.lstChamados = [];
    this.lstNaoOcorrencias = [];
    this.showDetalhesNaoOcorrencia = false;

    if (this.formListarChamado.invalid && this.userLogado?.codigoPerfil != Perfil.GestorConviva) {
      this.showPesquisa = false;
      return;
    }

    this.showPesquisa = true;
    this.spinnerService.show();
    const parametros = this.SetParametrosChamados();

    if (!parametros.codigoChamado && !parametros.codigoDiretoria && !parametros.codigoEscola) {
      if (!this.CoordenadorPsicologo) {
        this.toastr.warning("Não é possivel fazer uma pesquisa sem nenhum filtro.");
        this.spinnerService.hide();
        return;
      }

      const diretoriasUsuario = this.mapDiretoriasPermitidas(this.userLogado?.DadosUsuario);
      if (diretoriasUsuario.length === 0) {
        this.toastr.warning("Nenhuma URE encontrada no escopo de acesso do perfil.");
        this.spinnerService.hide();
        return;
      }

      await this.pesquisarChamadosMultiplasDiretorias(parametros, diretoriasUsuario);
      this.spinnerService.hide();
      return;
    }


    if (!parametros.dataInicio && !parametros.dataFim) {

    }

    else if (parametros.dataInicio && !parametros.dataFim) {
      parametros.dataFim = new Date();
      this.form.dataFim.setValue(parametros.dataFim);
    }
    else if (!parametros.dataInicio && parametros.dataFim) {
      this.toastr.warning("Datas inválidas! Selecione datas válidas para pesquisar.");
      this.spinnerService.hide();
      return;
    }

    if (parametros.dataInicio && parametros.dataFim && parametros.anoAtual) {
      const anoInicio = new Date(parametros.dataInicio).getFullYear();
      const anoFim = new Date(parametros.dataFim).getFullYear();

      if (anoInicio !== parametros.anoAtual || anoFim !== parametros.anoAtual) {
        this.toastr.warning("O ano das datas dos períodos deve ser igual ao campo do Ano.");
        this.spinnerService.hide();
        return;
      }
    }

    if (parametros.codigoSubCategoria != 42) {
      const resultadoBusca = await this.buscarListaChamados(parametros);
      if (!resultadoBusca.sucesso) {
        this.spinnerService.hide();
        return;
      }

      this.lstChamados = resultadoBusca.chamados;
      this.ordenarChamadosPorDataInclusao();
      this.lstAllChamados = [...this.lstChamados];
      this.exibirMensagemSemResultadosChamados();

      if (parametros.codigoDiretoria && parametros.codigoEscola) {
        const resultAlunos = await lastValueFrom(await this.chamadoService.getAlunosRecorrentes(parametros))
          .catch((err) => {
            return this.ConvivaErrors.handleResultError(err);
          });

        if (!resultAlunos.isSucess) {
          this.toastr.error(resultAlunos.message, resultAlunos.title);
          this.spinnerService.hide();
          return;
        }

        this.alunosRecorrentes = resultAlunos.data;
      }

      this.setParametrosNotificacoes();

    } else {
      const result = await lastValueFrom(await this.naoOcorrenciasService.getNaoOcorrencias(parametros))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });
      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }
      this.lstNaoOcorrencias = result.data;
    }

    this.spinnerService.hide();

  }

  public SetParametrosChamados(): ListarChamados {
    const chamado = new ListarChamados();
    chamado.codigoDiretoria = this.form?.codigoDiretoria.value;
    chamado.codigoEscola = this.form?.codigoEscola.value;
    chamado.codigoTurno = this.form?.codigoTurno.value;
    chamado.codigoGravidade = this.form?.codigoGravidade.value;
    chamado.ordenacaoCrescente = true;
    chamado.codigoSubCategoria = this.form?.codigoSubCategoria.value;
    chamado.codigoChamado = this.form?.codigoChamado.value;
    chamado.anoAtual = this.form?.anoAtual.value;
    chamado.dataInicio = this.toDateOrNull(this.form?.dataInicio.value) as Date | undefined;
    chamado.dataFim    = this.toDateOrNull(this.form?.dataFim.value) as Date | undefined;

    return chamado;
  }

  public setParametrosNotificacoes() {
    if (this.parametroIdChamado != null && this.parametroIdEnvolvido != null) {
      const chamadoParametro = this.lstChamados.filter(x => x.codigoChamado == this.parametroIdChamado && x.codigoEnvolvido == this.parametroIdEnvolvido).find(y => y.codigoChamado == this.parametroIdChamado);
      if (chamadoParametro != undefined)
        this.GetEnvolvidos(chamadoParametro);
    }
  }

  public async GetEnvolvidos(chamado: ListarChamados, el?: HTMLElement) {
    sessionStorage.setItem('dataHistorico', String(new Date(chamado.dataChamado).getFullYear()));
    this.spinnerService.show();
    this.statusCriada = null;
    this.statusFechada = null;
    const menu = document.getElementsByClassName("time-line")
    if (menu.length > 0) {
      const teste = menu.item(0) as HTMLElement;
      teste.className = "sidebar-chamado";
    }
    const result = await lastValueFrom(await this.envolvidoService.GetEnvolvidosPorChamado(chamado.codigoChamado))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    this.lstEnvolvidos = result.data;
    const envolvidoSelecionado = this.lstEnvolvidos.find(s => s.tipoPessoa == 3 || s.tipoPessoa == 2)
      ?? this.lstEnvolvidos.find(s => s.tipoPessoa == 1)
      ?? this.lstEnvolvidos[0];

    if (envolvidoSelecionado?.codigoEnvolvido)
      chamado.codigoEnvolvido = Number(envolvidoSelecionado.codigoEnvolvido);

    this.chamadoSeleccionado = chamado;
    this.showHistorico = true;
    this.showMenu = false;
    this.showStatus = false;
    this.showConteudoChamado = true;
    this.spinnerService.hide();
    this.chamadoSelecionado = chamado.codigoChamado;
    if (el)
      this.scrollTo(el);
  }

  public Voltar() {
    this.showHistorico = false;
    this.showConteudoChamado = false;
    this.showStatus = false;
    this.showMenu = true;
    const menu = document.getElementsByClassName("sidebar-chamado").item(0) as HTMLElement;
    if (menu != null)
      menu.className = "time-line";
  }

  public OnVisualizarChamado(id: number) {
    this.router.navigate(['/detalhe/', id]);
  }

  public FiltraChamadosAtuais(event: any) {
    if (event != undefined) {
      this.lstChamados = this.lstAllChamados.filter(item => item.codigoGravidade === event.id);
    } else {
      this.lstChamados = this.lstAllChamados;
    }
  }

  public OnExcluirChamado(codigoChamdo: number) {
    this.showModalExcluirChamado = true;
    this.descricaoExclusao = `Deseja remover o chamado ?`;
    this.chamadoARemover = codigoChamdo;
  }

  public async ExluirChamado(codigoChamado: number) {
    this.spinnerService.show();
    const chamadoDeletar: ChamadoDeletar = {
      cdChamado: codigoChamado,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    }
    const result = await lastValueFrom(await this.chamadoService.setDeletarChamado(chamadoDeletar))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.hide();
    this.toastr.success('Chamado removido com sucesso!');
    this.OnPesquisar();
    this.FecharModalExclusao();
  }




  public FecharModalExclusao() {
    this.showModalExcluirChamado = false;
    this.descricaoExclusao = "";
    this.chamadoARemover = 0;
  }

  public StatusChamado() {
    this.showStatus = true;
    this.showConteudoChamado = false;
  }

  public async OnStatusChamado(ic: number, ie: any) {
    this.spinnerService.show();
    const response = await lastValueFrom(this.chamadoService.getChamadoPorId(ic));
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.detalheChamado = response.data;
    if (this.detalheChamado != null) {
      const di = this.detalheChamado.cdDiretoria;
      const es = this.detalheChamado.cdEscola;
      const an = this.detalheChamado.dtChamado;
      const anN = new Date(an).getFullYear();

      this.router.navigate(['/listar-chamados/', ic, ie, di, es, anN]);
    }
    this.form.codigoDiretoria.enable();
    this.spinnerService.hide();
  }

  public getInfosNaoOcorrencia(item: ListarNaoOcorrencias) {

    this.spinnerService.show();
    this.statusCriada = null;
    this.statusFechada = null;
    const menu = document.getElementsByClassName("time-line")
    if (menu.length > 0) {
      const teste = menu.item(0) as HTMLElement;
      teste.className = "sidebar-chamado";
    }


    this.naoOcorrenciaSelecionada = this.lstNaoOcorrencias.find(s => s.codigoNaoOcorrencia == item.codigoNaoOcorrencia);
    this.showMenu = false;
    this.showStatus = false;
    this.showHistorico = true;
    this.showDetalhesNaoOcorrencia = true;
    this.spinnerService.hide();

  }
  public formatDate(data?: Date) {
    if (data == undefined) return;
    return formatDate(data, 'dd/MM/yyyy HH:mm', this.locale);
  }

  public AbrirModalConcluirChamado(codigoChamdo: number) {
    this.showModalConcluirChamado = true;
    this.descricaoConcluir = `Deseja concluir o chamado deste Envolvido ?`;
    this.chamadoAConcluir = codigoChamdo;
  }
  public FecharModalConcluir() {
    this.showModalConcluirChamado = false;
  }
  public async ConcluirChamado() {
    const objetoHistorico: HistoricoChamado = {
      codigoChamado: this.chamadoSeleccionado.codigoChamado,
      codigoEnvolvido: this.chamadoSeleccionado.codigoEnvolvido,
      descricaoHistorico: 'Chamado deste envolvido concluído.',
      statusChamado: 6,
      nomeArquivo: "",
      caminhoArquivo: "",
      conteudo: "",
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    };
    this.FecharModalConcluir();
    this.spinnerService.show();
    const result = await lastValueFrom(await this.concluirService.setCadastrarConcluirChamadoEnvolvidos(objetoHistorico))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    this.toastr.success('Chamado deste envolvido concluído com sucesso.');
    this.OnPesquisar();
    this.spinnerService.hide();
  }
  public podeConcluirChamado(chamado: ListarChamados) {
    return this.userLogado?.funcionalidades?.includes(2) &&
      this.chamadoSeleccionado.status != 4 &&
      (this.chamadoSeleccionado.semEnvolvido || this.chamadoSeleccionado.codigoCategoria == 6 || this.chamadoSeleccionado.status == 3);
  }

  public EventTresPontos(event: string) {

    if (event === "Pesquisar") {
      this.OnPesquisar();
    }
  }

  scrollTo(el: HTMLElement) {
    el.scrollIntoView();
  }

  private async getDiretoriasPerfilPsicologo() {
    this.spinnerService.show();
    const codigoPolo = Number(this.userLogado?.codigoPolo ?? 0);
    if (!codigoPolo) {
      this.spinnerService.hide();
      return;
    }

    const response = await lastValueFrom(this.psicologoService.getDiretoriaPorPolo(codigoPolo))
      .catch((err) => this.ConvivaErrors.handleResultError(err));
    if (!response?.isSucess) {
      this.toastr.error(response?.message ?? 'Erro ao carregar UREs do polo.');
      this.spinnerService.hide();
      return;
    }

    this.diretorias = await this.filtrarDiretoriasPorAtribuicoesPsicologo(response.data ?? [], codigoPolo);

    if (this.diretorias.length === 0) {
      this.form.codigoDiretoria.setValue(null);
      this.form.codigoDiretoria.disable();
      this.toastr.warning('Nenhuma URE ativa encontrada na SED para este polo.');
      this.spinnerService.hide();
      return;
    }

    const codigoDiretoriaLogin = Number(this.userLogado?.codigoDiretoria ?? 0);
    if (codigoDiretoriaLogin > 0 && this.diretorias.some(d => Number(d.codigoDiretoria) === codigoDiretoriaLogin)) {
      this.form.codigoDiretoria.setValue(codigoDiretoriaLogin);
    } else if (this.diretorias.length === 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
    } else {
      this.form.codigoDiretoria.setValue(null);
    }

    if (this.form.codigoDiretoria.value) {
      await this.getEscolas();
    }

    if (this.diretorias.length === 1) {
      this.form.codigoDiretoria.disable();
    } else {
      this.form.codigoDiretoria.enable();
    }
    this.spinnerService.hide();
  }

  private async filtrarDiretoriasPorAtribuicoesPsicologo(diretoriasPolo: Diretoria[], codigoPolo: number): Promise<Diretoria[]> {
    let codigosAtribuidos = this.obterCodigosDiretoriasAtribuidasLogin(codigoPolo);

    if (codigosAtribuidos.size === 0) {
      const cpf = this.userLogado?.cpf?.replace(/\D/g, '') ?? '';
      if (cpf) {
        const response = await lastValueFrom(this.psicologoService.getPsicologoAtribuicoesPorCpf(cpf))
          .catch((err) => this.ConvivaErrors.handleResultError(err));
        if (!response?.isSucess) {
          this.toastr.error(response?.message ?? 'Não foi possível carregar as atribuições do psicólogo na SED.');
          return [];
        }

        const escolas = response.data?.escolas ?? response.data?.Escolas ?? [];
        codigosAtribuidos = new Set(
          escolas
            .map((item: any) => Number(item.codigoDiretoria ?? item.CodigoDiretoria ?? 0))
            .filter((codigo: number) => codigo > 0)
        );
      }
    }

    if (codigosAtribuidos.size === 0) {
      return [];
    }

    return diretoriasPolo.filter((diretoria) =>
      codigosAtribuidos.has(Number(diretoria.codigoDiretoria))
    );
  }

  private obterCodigosDiretoriasAtribuidasLogin(codigoPolo: number): Set<number> {
    const atribuicoes = (this.userLogado?.DadosUsuario ?? [])
      .filter((item) => item.CodigoDiretoria > 0);

    const atribuicoesDoPolo = atribuicoes
      .filter((item) => Number(item.CodigoPolo) === Number(codigoPolo));

    const origem = atribuicoesDoPolo.length > 0 ? atribuicoesDoPolo : atribuicoes;

    return new Set(origem.map((item) => Number(item.CodigoDiretoria)));
  }

  private mapDiretoriasPermitidas(atribuicoes: AtribuicaoLoginSed[] | undefined): Diretoria[] {
    const diretorias: Diretoria[] = [];

    (atribuicoes ?? []).forEach((item: AtribuicaoLoginSed) => {
      if (diretorias.some(x => x.codigoDiretoria === item.CodigoDiretoria)) {
        return;
      }

      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      diretorias.push(diretoria);
    });

    return diretorias;
  }

  limpaCamposDiretoriaEscola() {
    this.form.codigoDiretoria.setValue(null);
    this.form.codigoEscola.setValue(null);
  }

  public validaAno(data: AbstractControl<any, any>) {
    const raw = data.value;

    if (raw === '' || raw === undefined || raw === null) {
      data.setValue(null, { emitEvent: false });
      return;
    }

    let parsed: Date | null = null;
    if (raw instanceof Date) {
      parsed = raw;
    } else if (typeof raw === 'string') {
      if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
        const [y, m, d] = raw.split('-').map(Number);
        parsed = new Date(y, m - 1, d);
      } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) {
        const [d, m, y] = raw.split('/').map(Number);
        parsed = new Date(y, m - 1, d);
      } else {
        parsed = new Date(raw);
      }
    }

    if (!parsed || isNaN(parsed.getTime())) {
      this.toastr.warning("Data inválida! Selecione uma data válida para pesquisar.");
      data.setValue(null, { emitEvent: false });
      return;
    }

    const ano = parsed.getFullYear();
    const anoFiltro = Number(this.form?.anoAtual.value);

    if (!Number.isFinite(anoFiltro)) return;

    if (ano !== anoFiltro) {
      this.toastr.warning("O ano da data deve ser igual ao campo 'Ano'.");
      data.setValue(null, { emitEvent: false });
    }
  }

  private async pesquisarChamadosMultiplasDiretorias(parametros: ListarChamados, diretorias: Diretoria[]) {
    const chamadosPorCodigo = new Map<number, ListarChamados>();

    for (const diretoria of diretorias) {
      const parametrosDiretoria = Object.assign(new ListarChamados(), parametros, {
        codigoDiretoria: diretoria.codigoDiretoria
      });
      const resultadoBusca = await this.buscarListaChamados(parametrosDiretoria);
      if (!resultadoBusca.sucesso) {
        return;
      }
      resultadoBusca.chamados.forEach((chamado) => chamadosPorCodigo.set(chamado.codigoChamado, chamado));
    }

    this.lstChamados = Array.from(chamadosPorCodigo.values());
    this.ordenarChamadosPorDataInclusao();
    this.lstAllChamados = [...this.lstChamados];
    this.exibirMensagemSemResultadosChamados();
    this.setParametrosNotificacoes();
  }

  private async buscarListaChamados(parametros: ListarChamados): Promise<{ sucesso: boolean; chamados: ListarChamados[] }> {
    const result = await lastValueFrom(await this.chamadoService.getListaChamados(parametros))
      .catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      return { sucesso: false, chamados: [] };
    }

    return { sucesso: true, chamados: result.data ?? [] };
  }

  private ordenarChamadosPorDataInclusao() {
    this.lstChamados = this.lstChamados.sort(
      (a, b) => new Date(b.dataInclusao).getTime() - new Date(a.dataInclusao).getTime()
    );
  }

  private exibirMensagemSemResultadosChamados() {
    if (this.lstChamados.length === 0) {
      this.toastr.info('Nenhum chamado encontrado para os filtros selecionados.');
    }
  }

  private toDateOrNull(v: any): Date | null {
    if (v === '' || v === undefined || v === null) return null;
    if (v instanceof Date) return isNaN(v.getTime()) ? null : v;

    if (typeof v === 'string') {
      if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
        const [y, m, d] = v.split('-').map(Number);
        const dt = new Date(y, m - 1, d);
        return isNaN(dt.getTime()) ? null : dt;
      }
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(v)) {
        const [d, m, y] = v.split('/').map(Number);
        const dt = new Date(y, m - 1, d);
        return isNaN(dt.getTime()) ? null : dt;
      }
    }
    const dt = new Date(v);
    return isNaN(dt.getTime()) ? null : dt;
  }


}
